import { Component, Input } from '@angular/core';
import { ModalService } from '@shared/services/modal.service';

@Component({
  selector: 'app-learning-video-modal',
  templateUrl: './learning-video-modal.component.html',
  styleUrls: ['./learning-video-modal.component.scss']
})
export class LearningVideoModalComponent {
  @Input() videoUrl?: string | null;
  @Input() videoTitle?: string | null;
  @Input() showClose = true;

  constructor(private _modalService: ModalService) {}

  onCloseModal() {
    this._modalService.close();
  }
}
